export default "__VITE_ASSET__4228032c__"